import { Modal } from "@/components";
import styles from "./index.module.scss";
import { useCommonStore } from "@/stores";
import { error_png } from "@/assets/images";
import { CloseSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";

const ReuploadModal = () => {
  const { t } = useTranslation();

  const reuploadOption = useCommonStore(state => state.reuploadOption);
  const setReuploadOption = useCommonStore(state => state.setReuploadOption);

  return (
    <Modal
      closeVisible={false}
    >
      <div
        className={styles["root"]}
      >
        <img
          className={styles["cover"]}
          src={error_png}
          alt=""
        />
        
        <span
          className={styles["title"]}
        >
          {reuploadOption.title}
        </span>

        <button
          className={styles["got_it_button"]}
          onClick={() => setReuploadOption({ show: false })}
        >
          <span>{t("select_face_modal_confirm_btn")}</span>
        </button>

        <button
          className={styles["close_button"]}
          onClick={() => setReuploadOption({ show: false })}
        >
          <CloseSvg></CloseSvg>
        </button>
      </div>
    </Modal>
  )
}

export default ReuploadModal;